export default __webpack_public_path__ + "static/media/koen.dff52260.png";